/* eslint-disable react/self-closing-comp */
// src/components/MaintenanceChecker.tsx
import React, { useEffect, useState } from 'react';

import ReportProblemIcon from '@mui/icons-material/ReportProblem';

import api from '../../services/api';
import { ModalContent, ModalWrapper } from './styles';
import { useToast } from '../../hooks/toast';

const MaintenanceChecker: React.FC = () => {
  const [maintenance, setMaintenance] = useState(false);
  const [textError, setTextError] = useState<any>();
  const { addToast } = useToast();

  useEffect(() => {
    const checkApiStatus = async () => {
      try {
        const response = await api.get('/core/version-application/');
      } catch (error: any) {
        if (error.response?.status === 503) {
          setTextError(error?.response?.data);
          setMaintenance(true);
          addToast({
            type: 'error',
            title: `${error?.response?.data?.message}`,
            description:
              error?.response?.data?.sub_message &&
              `${error?.response?.data?.sub_message}`,
          });
        }
      }
    };
    checkApiStatus();
  }, []);

  useEffect(() => {
    if (maintenance) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [maintenance]);

  if (!maintenance) return null;

  return (
    <ModalWrapper>
      <ModalContent>
        <ReportProblemIcon style={{ fontSize: 80, color: 'var(--orange)' }} />
        {textError?.message ? (
          <div>
            <h1>{textError?.message}</h1>
            <p className="Conctact">{textError?.sub_message}</p>
          </div>
        ) : (
          <div>
            <h1>Site em manutenção</h1>
            <p>
              O site está passando por uma manutenção programada no momento.
              Tente novamente mais tarde.
            </p>
            <p className="Conctact">
              Em caso de dúvidas entre em contato pelo telefone (31) 3248-7300
              ou email: sac@tranfsacil.com.br
            </p>
          </div>
        )}
      </ModalContent>
    </ModalWrapper>
  );
};

export default MaintenanceChecker;
